import axiosInstance from "../../apiAxios/axiosInstance";

export const SolutionList = async (payload) => {
  const response = await axiosInstance.post("/admin/solutions/list", payload);
  return response.data;
};

export const AddSolution = async (payload) => {
  const response = await axiosInstance.post("/admin/solutions/store", payload);
  return response.data;
};

export const ViewSolution = async (payload) => {
  const response = await axiosInstance.post("/admin/solutions/show", payload);
  return response.data;
};

export const UpdateSolution = async (payload) => {
  const response = await axiosInstance.post("/admin/solutions/update", payload);
  return response.data;
};

export const DeleteSolution = async (payload) => {
  const response = await axiosInstance.post("/admin/solutions/delete", payload);
  return response.data;
};

export const SolutionChangeStatus = async (payload) => {
  const response = await axiosInstance.post("/admin/solutions/status-update", payload);
  return response.data;
};

export const SectionList = async (payload) => {
  const response = await axiosInstance.post("/admin/sections/list", payload);
  return response.data;
};

export const AddSection = async (payload) => {
  const response = await axiosInstance.post("/admin/sections/store", payload);
  return response.data;
};

export const ViewSection = async (payload) => {
  const response = await axiosInstance.post("/admin/sections/show", payload);
  return response.data;
};

export const UpdateSection = async (payload) => {
  const response = await axiosInstance.post("/admin/sections/update", payload);
  return response.data;
};

export const DeleteSection = async (payload) => {
  const response = await axiosInstance.post("/admin/sections/delete", payload);
  return response.data;
};

export const SectionChangeStatus = async (payload) => {
  const response = await axiosInstance.post("/admin/sections/status-update", payload);
  return response.data;
};

export const ItemList = async (payload) => {
  const response = await axiosInstance.post("/admin/items/list", payload);
  return response.data;
};
export const AddItem = async (payload) => {
  const response = await axiosInstance.post("/admin/items/store", payload);
  return response.data;
};

export const ViewItem = async (payload) => {
  const response = await axiosInstance.post("/admin/items/show", payload);
  return response.data;
};

export const UpdateItem = async (payload) => {
  const response = await axiosInstance.post("/admin/items/update", payload);
  return response.data;
};

export const DeleteItem = async (payload) => {
  const response = await axiosInstance.post("/admin/items/delete", payload);
  return response.data;
};

export const ItemChangeStatus = async (payload) => {
  const response = await axiosInstance.post("/admin/items/status-update", payload);
  return response.data;
};